import { createSlice } from '@reduxjs/toolkit';
import { setCurrent } from './thunk';
import { RenovationViewsStaticsRules } from '../../domain/constants/RenovationFieldsStaticsRules';
import { RenovationView } from '../../domain/constants/RenovationView';

export const initialStateRenovation = {
  title: '',
  currentView: RenovationView.Dashboard,
  url: RenovationViewsStaticsRules[RenovationView.Dashboard].url,
  error: '',
  loading: false,
  actionInProcess: false,
  process: {},
};

// Create Redux state slice
const renovationSlice = createSlice({
  name: 'renovation',
  initialState: initialStateRenovation,
  reducers: {
    // Define reducers
  },
  extraReducers: (builder) => {
    builder.addCase(setCurrent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(setCurrent.fulfilled, (state, action) => {
      const { renovation, error } = action.payload;
      state.currentView = renovation.currentView;
      state.url = renovation.url;
      state.actionInProcess = renovation.actionInProcess;
      state.process = renovation.process;
      state.title = renovation.title;
      state.loading = false;
      state.error = error;
    });
    builder.addCase(setCurrent.rejected, (state) => {
      state.error = 'Error en el envío';
    });
  },
});

export const renovationReducer = renovationSlice.reducer;
export const {} = renovationSlice.actions;
export default renovationSlice.reducer;
